import gql from 'graphql-tag';

export const buildQueryNameForField = fieldName =>
  `compositions_CaseRequestsPanel_${fieldName}TireOptionsQuery`;

const buildQueryForField = fieldName => {
  const name = buildQueryNameForField(fieldName);

  return gql`
    query ${name} ($filters: TireOptionsFilters!, $select: TireSelectOption!) {
      tiresOptions(input: { filters: $filters, select: $select }) {
        options { id name generic }
      }
    }
  `;
};

export default buildQueryForField;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/TireOptionsDropdownCell/tireOptionsQuery.js